import { FC } from 'react'
import { useRecoilValue } from 'recoil'
import * as userListsModalAtoms from 'src/atoms/user-lists/user-lists-modal'
import { CsvUploadContent } from 'src/components/user-lists-modal/csv-upload-content'
import { MatchDataContent } from 'src/components/user-lists-modal/match-data-content'
import { MatchDataResultsContent } from 'src/components/user-lists-modal/match-data-results-content'
import { UserListsContent } from 'src/components/user-lists-modal/user-lists-content'
import { ShapefileUploadContent } from 'src/components/user-lists-modal/shapefile-upload-content'
export const Content: FC = () => {
  const currentSection = useRecoilValue(userListsModalAtoms.currentSection)

  if (currentSection === 'user-lists' || currentSection === 'user-list-detail') {
    return <UserListsContent />
  }

  if (currentSection === 'upload-csv') {
    return <CsvUploadContent />
  }

  if (currentSection === 'match-data') {
    return <MatchDataContent />
  }

  if (currentSection === 'match-data-results') {
    return <MatchDataResultsContent />
  }

  if (currentSection === 'upload-shapefile') {
    return <ShapefileUploadContent />
  }

  return null
}
